import bwipjs from "bwip-js/browser";
import { useMemo } from "react";

import { cn } from "@/lib/utils";

export function ConfigurationScanDataMatrix({
  text,
  className,
  sizePx = 48,
  ariaLabel,
  title,
  onActivate,
}: {
  text: string;
  className?: string;
  sizePx?: number;
  ariaLabel: string;
  title?: string;
  onActivate?: () => void;
}): JSX.Element {
  const svgMarkup = useMemo(() => {
    try {
      return bwipjs.toSVG({
        bcid: "datamatrix",
        text,
        scale: 4,
        backgroundcolor: "ffffff",
      });
    } catch {
      return "";
    }
  }, [text]);

  const matrixBody =
    svgMarkup === "" ? (
      <span
        className="flex items-center justify-center text-[10px] text-slate-400"
        style={{ width: sizePx, height: sizePx }}
      >
        …
      </span>
    ) : (
      <div
        className="flex shrink-0 items-center justify-center [&>svg]:block [&>svg]:h-full [&>svg]:w-full"
        style={{ width: sizePx, height: sizePx }}
        aria-hidden={onActivate != null ? true : undefined}
        dangerouslySetInnerHTML={{ __html: svgMarkup }}
      />
    );

  if (onActivate == null) {
    return (
      <div className={className} aria-label={ariaLabel} title={title}>
        {matrixBody}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={cn(
        "touch-manipulation rounded border border-slate-300 bg-white p-1 shadow-sm transition-colors hover:bg-slate-50 active:bg-slate-100",
        className,
      )}
      aria-label={ariaLabel}
      title={title}
      onClick={onActivate}
    >
      {matrixBody}
    </button>
  );
}
